// extracted by mini-css-extract-plugin
export default {"container":"BuildZone_container__++HVR","blank":"BuildZone_blank__y6Ak8","zone":"BuildZone_zone__3NBq+"};